<script setup>
const filter = defineModel({ type: Object, ...{
  required: true
} });
defineProps({
  readOnly: {
    type: Boolean,
    default: false
  }
});
</script>

<template>
    <label class="flex flex-col gap-6" :for="`${filter.value}-slider`">
        <span v-if="filter.name">
            {{ filter.name }}
        </span>
        <ChargemapSliderV2
            :id="`${filter.value}-slider`"
            v-model="filter.range"
            :min="filter.min"
            :max="filter.max"
            :step="filter.step || 0.1"
            :disabled="readOnly"
        />
    </label>
</template>
